"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceSeriesButton = InvoiceSeriesButton;
exports.InvoiceSeriesModal = InvoiceSeriesModal;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const invoiceSeriesApi_1 = require("../invoiceSeriesApi");
function newInvoicesLabel(count) {
    if (count === 1)
        return "1 nową fakturę";
    const few = count % 10 >= 2 && count % 10 <= 4 && !(count % 100 >= 12 && count % 100 <= 14);
    return count + (few ? " nowe faktury" : " nowych faktur");
}
const formatDate = (date) => date.split("-").reverse().join(".");
const formatAmount = (amount) => amount.toLocaleString("pl-PL", { style: "currency", currency: "PLN" });
function InvoiceSeriesButton({ invoice }) {
    const [show, setShow] = (0, react_1.useState)(false);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: () => setShow(true) }, "Utw\u00F3rz seri\u0119"),
        react_1.default.createElement(InvoiceSeriesModal, { invoice: invoice, show: show, onHide: () => setShow(false) }));
}
function InvoiceSeriesModal({ invoice, show, onHide }) {
    const [totalCount, setTotalCount] = (0, react_1.useState)("2");
    const [intervalMonths, setIntervalMonths] = (0, react_1.useState)("1");
    const [firstSaleDate, setFirstSaleDate] = (0, react_1.useState)(null);
    const [preview, setPreview] = (0, react_1.useState)(null);
    const [previewKey, setPreviewKey] = (0, react_1.useState)("");
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [saving, setSaving] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)("");
    const [created, setCreated] = (0, react_1.useState)(null);
    const inFlight = (0, react_1.useRef)(false);
    const attempt = (0, react_1.useRef)(null);
    const [uncertain, setUncertain] = (0, react_1.useState)(false);
    const input = {
        sourceInvoiceId: invoice.id,
        totalCount: Number(totalCount),
        intervalMonths: Number(intervalMonths),
        firstSaleDate,
    };
    const key = JSON.stringify(input);
    const valid = Number.isSafeInteger(input.totalCount) && input.totalCount >= 2 && input.totalCount <= 100
        && Number.isSafeInteger(input.intervalMonths) && input.intervalMonths >= 1 && input.intervalMonths <= 12 && firstSaleDate !== "";
    (0, react_1.useEffect)(() => {
        if (!show || !valid || created !== null)
            return;
        const controller = new AbortController();
        setLoading(true);
        setError("");
        (0, invoiceSeriesApi_1.invoiceSeriesRequest)("invoiceSeries/preview", JSON.parse(key), controller.signal)
            .then(result => {
            if (!controller.signal.aborted) {
                setPreview(result);
                setPreviewKey(key);
            }
        })
            .catch(err => {
            if (!controller.signal.aborted) {
                setError(err.message);
                setPreviewKey("");
            }
        })
            .finally(() => { if (!controller.signal.aborted)
            setLoading(false); });
        return () => controller.abort();
    }, [show, key, valid, created]);
    async function submit(event) {
        event.preventDefault();
        if (inFlight.current || created !== null || !valid || loading || previewKey !== key)
            return;
        inFlight.current = true;
        setSaving(true);
        setError("");
        try {
            if (!attempt.current || attempt.current.key !== key)
                attempt.current = { key, requestId: crypto.randomUUID() };
            const result = await (0, invoiceSeriesApi_1.invoiceSeriesRequest)("invoiceSeries", {
                ...input, requestId: attempt.current.requestId,
            });
            setCreated(result.invoiceIds.length);
            setUncertain(false);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : "Nie udało się potwierdzić zapisu.");
            setUncertain(!(err instanceof Error && "status" in err && Number(err.status) < 500));
        }
        finally {
            inFlight.current = false;
            setSaving(false);
        }
    }
    function close() {
        if (inFlight.current)
            return;
        onHide();
        if (created !== null) {
            setCreated(null);
            attempt.current = null;
            setPreviewKey("");
        }
    }
    return react_1.default.createElement(react_bootstrap_1.Modal, { show: show, onHide: close, size: "lg", backdrop: saving ? "static" : true, keyboard: !saving },
        react_1.default.createElement(react_bootstrap_1.Form, { onSubmit: submit },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: !saving },
                react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Utw\u00F3rz seri\u0119")),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info" }, "Nowe faktury zostan\u0105 zapisane od razu jako \u201ENa p\u00F3\u017Aniej\u201D, bez numer\u00F3w. Ka\u017Cd\u0105 faktur\u0119 nale\u017Cy p\u00F3\u017Aniej wystawi\u0107 osobno. Opisy i kwoty pozostan\u0105 bez zmian."),
                created !== null ? react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success", role: "status" },
                    "Utworzono ",
                    newInvoicesLabel(created),
                    ". Faktura \u017Ar\u00F3d\u0142owa pozosta\u0142a bez zmian.") : react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("fieldset", { disabled: saving || uncertain },
                        react_1.default.createElement("div", { className: "row g-3 mb-3" },
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "col-sm-6", controlId: "series-count" },
                                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "\u0141\u0105czna liczba faktur"),
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "number", min: 2, max: 100, step: 1, required: true, value: totalCount, onChange: e => setTotalCount(e.target.value) })),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "col-sm-6", controlId: "series-interval" },
                                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Powtarzaj co \u2026 miesi\u0119cy"),
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "number", min: 1, max: 12, step: 1, required: true, value: intervalMonths, onChange: e => setIntervalMonths(e.target.value) })),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "col-sm-6", controlId: "series-first-date" },
                                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Data pierwszej nowej faktury"),
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", min: "1000-01-01", max: "9999-12-31", required: true, value: firstSaleDate ?? preview?.saleDates[1] ?? "", onChange: e => setFirstSaleDate(e.target.value) })),
                            react_1.default.createElement("div", { className: "col-sm-6 d-flex align-items-end" },
                                react_1.default.createElement(react_bootstrap_1.Button, { variant: "link", onClick: () => setFirstSaleDate(null), disabled: firstSaleDate === null }, "Przywr\u00F3\u0107 dat\u0119 domy\u015Bln\u0105")))),
                    react_1.default.createElement("p", { className: "small text-muted" }, "Domy\u015Blnie zachowujemy dzie\u0144 sprzeda\u017Cy faktury \u017Ar\u00F3d\u0142owej. Po r\u0119cznej zmianie daty zachowujemy wybrany dzie\u0144. W kr\u00F3tszym miesi\u0105cu u\u017Cywamy ostatniego dnia, a potem wracamy do dnia bazowego."),
                    error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", role: "alert" }, error),
                    uncertain && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning" }, "Zapis nie zosta\u0142 potwierdzony. Pon\u00F3w t\u0119 sam\u0105 operacj\u0119 przyciskiem poni\u017Cej. Nie utworzy ona duplikat\u00F3w. Parametry zachowano r\u00F3wnie\u017C po zamkni\u0119ciu tego okna."),
                    !valid && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning" }, "Podaj liczb\u0119 faktur od 2 do 100, ca\u0142kowity odst\u0119p od 1 do 12 miesi\u0119cy i poprawn\u0105 dat\u0119."),
                    loading && react_1.default.createElement("div", { role: "status" },
                        react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm" }),
                        " Aktualizowanie podgl\u0105du\u2026"),
                    valid && !loading && previewKey === key && preview && react_1.default.createElement("div", { style: { maxHeight: "40vh", overflowY: "auto" } },
                        react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, size: "sm", responsive: true },
                            react_1.default.createElement("thead", null,
                                react_1.default.createElement("tr", null,
                                    react_1.default.createElement("th", { scope: "col" }, "Lp."),
                                    react_1.default.createElement("th", { scope: "col" }, "Dokument"),
                                    react_1.default.createElement("th", { scope: "col" }, "Planowana data sprzeda\u017Cy"),
                                    react_1.default.createElement("th", { scope: "col" }, "Kwota netto"),
                                    react_1.default.createElement("th", { scope: "col" }, "Kwota brutto"))),
                            react_1.default.createElement("tbody", null, preview.saleDates.map((date, index) => react_1.default.createElement("tr", { key: index },
                                react_1.default.createElement("td", null, index + 1),
                                react_1.default.createElement("td", null, index === 0 ? "Istniejąca (źródłowa)" : "Nowa (Na później)"),
                                react_1.default.createElement("td", null, formatDate(date)),
                                react_1.default.createElement("td", { className: "text-nowrap" }, formatAmount(preview.netAmount)),
                                react_1.default.createElement("td", { className: "text-nowrap" }, formatAmount(preview.grossAmount))))))))),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: close, disabled: saving }, "Zamknij"),
                created === null && react_1.default.createElement(react_bootstrap_1.Button, { type: "submit", variant: "primary", disabled: saving || loading || !valid || previewKey !== key }, saving ? react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm" }),
                    " Tworzenie\u2026") : "Utwórz " + newInvoicesLabel(valid ? input.totalCount - 1 : 0)))));
}
